import { useEffect, useMemo, useState } from 'react';
import { getPublicTeamCalendar } from 'data/repositories/TeamCalendar';
import { TeamCalendarEvent, TeamCalendarPublicCalendarResponse } from 'data/schemas/TeamCalendar';
import { getEventsForDate, getMonthRange } from './components/dateUtils';

function TeamCalendarPublicViewModel(shareToken: string) {
    const [currentMonth, setCurrentMonth] = useState(new Date());
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [calendar, setCalendar] = useState<TeamCalendarPublicCalendarResponse | null>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const loadCalendar = async () => {
        try {
            setIsLoading(true);
            setErrorMessage('');
            const range = getMonthRange(currentMonth);
            const result = await getPublicTeamCalendar(shareToken, range);
            setCalendar(result);
        } catch (error) {
            const message = (error as Error).message;
            setErrorMessage(message);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        loadCalendar();
    }, [shareToken, currentMonth]);

    const events = useMemo<TeamCalendarEvent[]>(() => calendar?.events ?? [], [calendar]);

    const selectedDateEvents = useMemo(() => {
        return getEventsForDate(selectedDate, events);
    }, [selectedDate, events]);

    return {
        currentMonth,
        selectedDate,
        calendar,
        events,
        isLoading,
        errorMessage,
        selectedDateEvents,
        setCurrentMonth,
        setSelectedDate
    };
}

export default TeamCalendarPublicViewModel;
